var $ea5a06d6bf3277a1$exports = {};
document.querySelectorAll('.sidebar li a').forEach((element)=>{
    element.classList.remove('bg-active', 'text-active-text');
});
document.querySelectorAll('.sidebar li:nth-child(4) a').forEach((element)=>{
    element.classList.add('bg-active', 'text-active-text');
});
document.querySelectorAll('.last-race-datetime').forEach((element)=>{
    if (element.innerText !== "") element.innerText = moment(element.innerText, "YYYY-MM-DD HH:mm").fromNow();
});


//# sourceMappingURL=star-racing-team-usa.a7f71c95.js.map
